import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="5"
    height="10"
    viewBox="0 0 5 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.26654 3.58663L1.20654 0.526625C1.08163 0.402458 0.912659 0.332764 0.736535 0.332764C0.560411 0.332764 0.391443 0.402458 0.266535 0.526625C0.204049 0.588601 0.154453 0.662335 0.120607 0.743574C0.0867616 0.824814 0.0693359 0.911951 0.0693359 0.999959C0.0693359 1.08797 0.0867616 1.1751 0.120607 1.25634C0.154453 1.33758 0.204049 1.41132 0.266535 1.47329L3.3332 4.52663C3.39569 4.5886 3.44528 4.66234 3.47913 4.74358C3.51298 4.82481 3.5304 4.91195 3.5304 4.99996C3.5304 5.08797 3.51298 5.1751 3.47913 5.25634C3.44528 5.33758 3.39569 5.41132 3.3332 5.47329L0.266535 8.52663C0.140999 8.65128 0.0701225 8.82069 0.0694974 8.9976C0.0688723 9.17451 0.13855 9.34442 0.263202 9.46996C0.387854 9.5955 0.557269 9.66637 0.734178 9.667C0.911087 9.66762 1.081 9.59795 1.20654 9.47329L4.26654 6.41329C4.64107 6.03829 4.85144 5.52996 4.85144 4.99996C4.85144 4.46996 4.64107 3.96163 4.26654 3.58663Z"
      fill="#151718"
    />
  </svg>
);

const DateNavigatorRight = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default DateNavigatorRight;
